import type VueRouter from 'vue-router';

const timer: TimeoutId | null = null;

export default function blankGuard(router: VueRouter) {
  router.afterEach(() => {
    if (window.__g_blank_checker__) {
      if (timer != null) {
        clearTimeout(timer);
      }

      // 3秒后检查是否存在白屏
      setTimeout(() => {
        window.__g_blank_checker__?.check();
      }, 3000);
    }
  });
}
